import { render } from "./registerByEmail.vue?vue&type=template&id=8dd7aff0"
import script from "./registerByEmail.vue?vue&type=script&lang=js"
export * from "./registerByEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__